module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "donut inline",
    attrs: {
      "viewBox": "0 0 100 100"
    }
  }, [_c('circle', {
    staticClass: "bg",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "40",
      "stroke-width": "20",
      "stroke": _vm.getBgColor
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "40",
      "stroke-width": "20",
      "stroke": _vm.getColor,
      "stroke-dasharray": "251.2",
      "stroke-dashoffset": _vm.getValue()
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce7ccc3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Minidonut.vue
// module id = 615
// module chunks = 1